// extracted by mini-css-extract-plugin
export default {"creator_empty":"creator_empty__d71d9a24","image":"image__d71d9a24","img":"img__d71d9a24","title":"title__d71d9a24","body":"body__d71d9a24"};